import { render, staticRenderFns } from "./RPTableGraphCard.vue?vue&type=template&id=867e980a&"
import script from "./RPTableGraphCard.vue?vue&type=script&lang=js&"
export * from "./RPTableGraphCard.vue?vue&type=script&lang=js&"
import style0 from "./RPTableGraphCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports